import { render } from "./Footer.vue?vue&type=template&id=6d318aaf&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6d318aaf&lang=scss"
script.render = render

export default script